import { gql } from 'apollo-boost';

export default gql`
  mutation updateOrderStatus($input: UpdateOrderStatusInput!) {
    updateOrderStatus(input: $input)
  }
`;
